export interface AmplifyError extends Error {
  name: string;
}

export const isAmplifyError = (error: unknown): error is { name: string; message?: string } => {
    return (
        typeof error === "object" &&
        error !== null &&
        "name" in error &&
        // @typescript-eslint/no-explicit-any
        typeof (error as any).name === "string"
    );
}

export const getSignUpErrorMessage = (error: AmplifyError): string => {
  switch (error.name) {
    case 'UsernameExistsException':
      return 'This email address is already in use. Please try logging in.';
    case 'InvalidPasswordException':
      return 'Your password does not meet the requirements. It must be at least 8 characters and include at least 1 number, at least 1 uppercase letter, at least 1 lowercase letter, at least 1 special character.';
    case 'InvalidParameterException':
      // This can happen for various reasons, often malformed email.
      return 'Please ensure all fields are filled out correctly.';
    default:
      return 'An unexpected error occurred. Please try again later.';
  }
};